<div class="container" aria-modal="true">
  <div mat-dialog-title class="dialog-title">
    <h1 mat-dialog-title>Edit GIS Skills</h1>
    <button mat-icon-button aria-label="close dialog" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div class="title_light">Selected User ({{users.length}}):</div>
    <ul class="margin-left-2">
      @for (user of users; track user) {
        <li>
          {{user.first_name}} {{user.last_name}} <span style="color: gray;">{{ displayExistingCerts(user) }}</span>
        </li>
      }
    </ul>
    <div class="title_light">Select GIS Skills to apply:</div>
    <div class="whole-line checkBoxGroup">
      <mat-checkbox [(ngModel)]="NIS_BAER">
        NIS-BAER
      </mat-checkbox>
      <mat-checkbox [(ngModel)]="VGIS">
        VGIS
      </mat-checkbox>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions>
    <div class="button-row">
      <button class="usa-button usa-button--secondary" mat-dialog-close>Cancel</button>
      <button class="usa-button"
              (click)="apply()">Apply</button>
    </div>
  </div>
</div>
